// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"messageBox--1r6A6","warning":"warning--20D8N","info":"info--1Eteh","content":"content--pb8Yr"};